import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = [{
    title: 'Guía Maestra PDF',
    desc: 'El protocolo paso a paso para pasar de la parálisis a la acción en 300 segundos.'
  }, {
    title: 'El Sistema Sensory Clear',
    desc: "La técnica táctica para 'reiniciar' tu cerebro cuando te sientes desbordado."
  }, {
    title: 'Protocolo de Blindaje',
    desc: 'Cómo crear una burbuja de enfoque que las notificaciones no puedan romper.'
  }, {
    title: 'Técnica de Dopamine Stacking',
    desc: 'El truco para mantener tu cerebro entretenido mientras haces el trabajo aburrido.'
  }, {
    title: 'Checklists de Emergencia',
    desc: "Qué hacer exactamente cuando el 'ruido' gana la batalla por la mañana."
  }];
  return <section className="py-20 relative" data-id="element-136">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-137">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-50 mb-12 text-center" data-id="element-138">
          Lo que obtienes hoy
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-139">
          {deliverables.map((item, index) => <div key={index} className={`bg-white/5 border border-white/10 rounded-2xl p-6 flex items-start gap-4 hover:bg-white/10 transition-all duration-300 hover:border-cyan-500/30 hover:shadow-[0_0_20px_rgba(34,211,238,0.1)] ${index === deliverables.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-140">
              <CheckCircle2Icon className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-141" />
              <div data-id="element-142">
                <h3 className="text-lg font-bold text-slate-100 mb-1" data-id="element-143">
                  {item.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-144">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}